export default __webpack_public_path__ + "static/media/progress_dsk.64128669.svg";